/* LUVA collection.

   Four small jobs: filter the wall by flavour family, keep that choice in the
   address bar so the back button and a shared link both work, keep the count
   honest, and keep the free delivery row in step with the real cart.

   The filter is client side on purpose for now, because the families live in
   section blocks rather than in product tags. The moment they become tags,
   the chips should become real links so each family gets its own URL. Until
   then the family lives in a query parameter, which gives the same three
   things a real URL gives: a working back button, a link that can be shared,
   and a reload that lands where the visitor was.
*/
(function () {
  var root = document.querySelector('[data-luva-coll]');
  if (!root) return;

  var PARAM = 'family';

  /* ---------- filter ---------- */
  var grid = root.querySelector('[data-luva-grid]');
  var chips = root.querySelectorAll('button[data-fam]');
  var count = root.querySelector('[data-luva-count]');
  var none = root.querySelector('[data-luva-none]');
  var bar = root.querySelector('[data-luva-bar]');
  var scroller = root.querySelector('[data-luva-scroll]');

  function known(fam) {
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].getAttribute('data-fam') === fam) return true;
    }
    return false;
  }

  function mark(fam) {
    for (var i = 0; i < chips.length; i++) {
      chips[i].setAttribute('aria-pressed', chips[i].getAttribute('data-fam') === fam ? 'true' : 'false');
    }
  }

  function apply(fam) {
    if (!grid) return;
    var cards = grid.children;
    var shown = 0;

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var mine = card.getAttribute('data-fam') || '';
      var on = fam === 'all' || mine === fam;
      card.hidden = !on;
      if (on) shown++;
    }

    if (count) count.textContent = shown;
    if (none) none.hidden = shown !== 0;
  }

  function calm() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* After a filter the grid can be shorter than the scroll position, which
     leaves the visitor looking at the footer instead of the result. Only then
     is the page moved, and only as far as the top of the grid under the bar,
     so a visitor who filters from the top never sees the page jump. */
  function reveal() {
    if (!grid) return;

    /* One frame later, so the hidden cards are already out of the layout and
       the bar is measured where it will actually sit. The resting place of
       the bar is read off the bar itself, so there is no height written down
       here that a change to the bar could make wrong. The browser is asked to
       bring the grid into view rather than being handed a pixel, because only
       the browser knows how far the shortened page can still scroll. */
    window.requestAnimationFrame(function () {
      var rest = bar ? (parseFloat(window.getComputedStyle(bar).top) || 0) + bar.offsetHeight : 0;
      grid.style.scrollMarginTop = rest + 12 + 'px';
      if (grid.getBoundingClientRect().top >= rest - 1) return;
      grid.scrollIntoView({ block: 'start', behavior: calm() ? 'auto' : 'smooth' });
    });
  }

  function write(fam) {
    if (!window.history || !window.history.pushState) return;
    var url = new URL(window.location.href);
    if (fam === 'all') url.searchParams.delete(PARAM);
    else url.searchParams.set(PARAM, fam);
    if (url.toString() === window.location.href) return;
    window.history.pushState({ luvaFamily: fam }, '', url.toString());
  }

  function choose(fam, push) {
    if (!known(fam)) fam = 'all';
    mark(fam);
    apply(fam);
    if (push) write(fam);
  }

  for (var i = 0; i < chips.length; i++) {
    (function (chip) {
      chip.addEventListener('click', function () {
        choose(chip.getAttribute('data-fam') || 'all', true);
        reveal();
      });
    })(chips[i]);
  }

  /* The family links in the reading block below point at this same page. They
     stay real links for a crawler and for a new tab, but on this page they
     move the chips instead of reloading. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('[data-luva-family-link]') : null;
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var fam = link.getAttribute('data-luva-family-link') || '';
    if (!known(fam)) return;
    e.preventDefault();
    choose(fam, true);
    reveal();
  });

  window.addEventListener('popstate', function () {
    var url = new URL(window.location.href);
    choose(url.searchParams.get(PARAM) || 'all', false);
  });

  /* A fade on the chip row, so a visitor on a narrow screen can see that the
     families carry on past the edge. */
  function edges() {
    if (!scroller) return;
    var over = scroller.scrollWidth - scroller.clientWidth;
    var sl = Math.abs(scroller.scrollLeft); /* RTL: scrollLeft is negative */
    scroller.setAttribute('data-start', sl > 4 ? 'true' : 'false');
    scroller.setAttribute('data-end', over > 4 && sl < over - 4 ? 'true' : 'false');
  }

  if (scroller) {
    scroller.addEventListener('scroll', edges, { passive: true });
    window.addEventListener('resize', edges);
    edges();
  }

  (function () {
    var url = new URL(window.location.href);
    var fam = url.searchParams.get(PARAM);
    if (fam) choose(fam, false);
  })();

  /* ---------- free delivery ---------- */
  var totalEl = root.querySelector('[data-luva-cart-total]');
  var togoEl = root.querySelector('[data-luva-togo]');
  var barEl = root.querySelector('[data-luva-progress]');
  if (!totalEl && !togoEl && !barEl) return;

  var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
  var format = root.getAttribute('data-money-format') || '{{amount}}';
  var togoText = root.getAttribute('data-togo') || '';
  var reachedText = root.getAttribute('data-reached') || '';

  /* Shopify hands the money format down as a Liquid style template, so the
     amount has to be rendered the same way the server would render it. */
  function money(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');

    return format
      .replace(/\{\{\s*amount\s*\}\}/g, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.'));
  }

  function paint(total) {
    /* A bar standing at zero asks for nothing and promises nothing, so it
       stays away until there is a first item to count. */
    root.setAttribute('data-cart-empty', total > 0 ? 'false' : 'true');

    if (totalEl) totalEl.innerHTML = money(total);

    if (togoEl) {
      var left = threshold - total;
      togoEl.innerHTML = left > 0 ? togoText.replace('[amount]', money(left)) : reachedText;
    }

    if (barEl && threshold > 0) {
      var pct = (total / threshold) * 100;
      barEl.style.width = (pct > 100 ? 100 : pct) + '%';
    }
  }

  function refresh() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        paint(cart.total_price);
      })
      .catch(function () {});
  }

  document.addEventListener('cart:update', refresh);
  document.addEventListener('cart-lines:update', refresh);
})();
